import { render } from "./SettingsBillingAndPaymentView.vue?vue&type=template&id=146f9189"
import script from "./SettingsBillingAndPaymentView.vue?vue&type=script&lang=js"
export * from "./SettingsBillingAndPaymentView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/ui/views/SettingsBillingAndPaymentView.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "146f9189"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('146f9189', __exports__)) {
    api.reload('146f9189', __exports__)
  }
  
  module.hot.accept("./SettingsBillingAndPaymentView.vue?vue&type=template&id=146f9189", () => {
    api.rerender('146f9189', render)
  })

}


export default __exports__